module.exports = __webpack_public_path__ + "img/overnight-travel.c86f7741.jpg";